module.exports = __webpack_public_path__ + "static/media/c.4e8999b1.png";